import React from 'react'
import { renderDropDown } from './ListNav'
import { navigations, toggleNav } from 'scripts/components/navigations/helpers/NavigationHelpers'
import { dispatcher } from '../NavigationDispatcher'
import Constants from 'scripts/base/Constants'
import PropTypes from 'prop-types'
import {getLang} from 'shared/i18n/react'

export default class PrimaryDropDown extends React.Component {
  constructor(props) {
    super(props)
    this.updateDom = this.updateDom.bind(this)
    this.lang = getLang()
  }

  updateDom(data) {
    if (data.id === this.props.id) {
      toggleNav({ hidden: false, component: this }, data, this.props)
    }
  }

  componentDidMount() {
    dispatcher.on(Constants.Navigations.TOGGLE_NAV_CLASS, this.updateDom)
  }

  componentWillUnmount() {
    dispatcher.off(Constants.Navigations.TOGGLE_NAV_CLASS, this.updateDom)
  }

  render() {
    return (
      <li className={`navbar-primary-links nav-item`}>
        <ul className="nav-item">
          {navigations[this.lang].primary.map((item) => {
            return renderDropDown(item, { listClasses: 'nav-item', aClasses: 'navbar-link' })
          })}
        </ul>
      </li>
    )
  }
}

PrimaryDropDown.propTypes = {
  id: PropTypes.string.isRequired,
  toggleWithId: PropTypes.func,
  dropdown: PropTypes.string
}



// WEBPACK FOOTER //
// ./assets/js/components/navigations/lists/PrimaryDropDown.jsx